import jrnParser from 'classes/jrnParser'

let _jrn, _state, _globalState, _PagingProfile
export default class GetPagingProfileController {
  constructor (gettextCatalog, $state, globalState, PagingProfile) {
    'ngInject'
    this._model = {}
    _state = $state
    _globalState = globalState
    _jrn = jrnParser
    _PagingProfile = PagingProfile

    this.placeholder = gettextCatalog.getString('Select a paging profile...')

    this.$onInit = () => {
      this.setViewValue = item => {
        this.ngModel.$setViewValue(item.id)
      }
    }
  }

  api (id = null) {
    return new _PagingProfile(id)
  }

  openLink () {
    _state.go('root.nav.pbx.devices.profiles.view.general', {
      id: _globalState.selectedPbx.domain,
      profileId: _jrn.parse(this.jrn).getResources()[1]
    })
  }
}
